import { useTranslation } from "react-i18next";
import { DropdownMenu } from "components/common/DropdownMenu";
import { ExportActionLabel } from "./ExportActionLabel";
import type { PlanNameChipProps } from "./types";

const EMPTY_EXPORT_ACTIONS: never[] = [];

export const PlanNameChip = ({
  name,
  isArchived = false,
  exportActions = EMPTY_EXPORT_ACTIONS,
}: PlanNameChipProps) => {
  const { t } = useTranslation();

  const singleAction = exportActions.length === 1 ? exportActions[0] : null;
  const hasMenu = exportActions.length > 1;

  return (
    <div className="absolute top-2 left-2 z-10 flex flex-col items-start bg-white/90 backdrop-blur-sm rounded px-2.5 py-1 text-xs text-gray-700 font-medium shadow-sm border border-gray-200 max-w-[50%] pointer-events-none">
      <span className="max-w-full truncate" title={name}>
        {isArchived && (
          <span className="font-semibold text-amber-600">
            {t("smartSurveyor.planFilter.archived")}:{" "}
          </span>
        )}
        {name}
      </span>
      {singleAction && (
        <button
          type="button"
          onClick={singleAction.onClick}
          className="pointer-events-auto mt-0.5"
        >
          <ExportActionLabel label={singleAction.label} hasMenu={false} />
        </button>
      )}
      {hasMenu && (
        <DropdownMenu
          className="pointer-events-auto mt-0.5"
          menuClassName="text-gray-700"
          trigger={
            <ExportActionLabel
              label={t("smartSurveyor.floorPlan.downloadAnnotatedPlan")}
              hasMenu
            />
          }
          items={exportActions.map((action) => ({
            label: action.label,
            onClick: action.onClick,
          }))}
        />
      )}
    </div>
  );
};
